import { useMutation } from "react-query";
import {
  ClosedVehiclePremiumRequestParams,
  correctVehiclePremium,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const correctVehiclePremiumFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: ClosedVehiclePremiumRequestParams;
}) => {
  return await correctVehiclePremium(rowVersion, params);
};

export function useCorrectVehiclePremium() {
  return useMutation(correctVehiclePremiumFn, {
    mutationKey: MUTATION_KEYS.correctVehiclePremium,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
